/**
 * Description: Error message that shows up in audit tool filter sections if any filter options are invalid
 */
import React from 'react';
import {
  Flash
} from 'AWS-UI-Components-React';

export class ErrorMessage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: ""
    };
    this.checkFilterOptions = this.checkFilterOptions.bind(this);
    this.handleDisplayErrorMessage = this.handleDisplayErrorMessage.bind(this);
  }

  handleDisplayErrorMessage() {
    if (this.state.errorMessage.length === 0) {
      return null;
    }

    return (
      <Flash
        header="ERROR:"
        type="error"
        content={this.state.errorMessage}
        dismissible={true}
      ></Flash>
    );
  }

  checkFilterOptions(filter_options) {
    this.setState((state, props) => { 
      if (filter_options.before_date.length > 0 && filter_options.before_date < filter_options.after_date) {
        return ({
          errorMessage: `Date Range ${filter_options.after_date} to ${filter_options.before_date} is not valid`
        });
      } else {
        return ({
          errorMessage: "" 
        });
      }
    });
    return this.state.errorMessage;
  }

  render() {
    return (
      this.handleDisplayErrorMessage()
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/filterErrorSection.jsx